module.exports = __webpack_public_path__ + "img/moon.65df0818.svg";